import React from 'react';
import styled from 'styled-components';

import {
	defaultInputStyles,
	FormGroup,
	inputTransition,
	Label
} from './styles';

const StyledInput = styled.input`
  ${() => defaultInputStyles()}
  ${() => inputTransition()}
`;

const Input = ({
	type, pattern, name, value, label, required, onChange, className, maxLength, autocomplete, ...rest
}) => (
	<FormGroup {...rest}>
		<StyledInput
			className={`${className} ${value && 'filled'}`}
			type={type && type}
			name={name}
			value={value}
			onChange={onChange}
			required={required ? true : undefined}
			maxLength={maxLength ? maxLength : undefined}
			autocomplete={autocomplete ? autocomplete : undefined}
			pattern={pattern ? pattern : undefined}
		/>
		<Label htmlFor={name}>{label}</Label>
		<span></span>
	</FormGroup>
);

export default Input;
